import { ISgSdkHandler, TriggerAction } from "./types";

declare const sdkHandler: ISgSdkHandler; 

export function loadingUpdate(progressPercentage) {
    sdkHandler.trigger(TriggerAction.LOADING_UPDATE, {
        progressPercentage,
    });
}

export function loadingComplete() {
    sdkHandler.trigger(TriggerAction.LOADING_COMPLETED, {
        callback: () => {},
    });
}

export function start() {
    sdkHandler.trigger(TriggerAction.START);
}